import rateLimit from 'axios-rate-limit';
import axios from 'axios';
import {
  findIndex,
  isArray,
  isObject,
  remove as removeFunc,
  uniqBy
} from 'lodash-es';
import store from 'Assets/js/Vuex/Store/store';
import globalTheme from 'Assets/js/components/globalTheme';
import cartContent from 'Templates/content/cart.json';
import cartService from 'Assets/js/components/cartService';
import events from 'Assets/js/components/events';

const triggerErrorLog = (error) => {
  axios.post('/wp-json/teams/v1/send', {
    error: { 'service: ': 'b2bCartHelper', error }
  });
};

function B2BCartServiceConstructor() {
  // Create axios instance
  const axiosInstance = axios.create();

  // Add rate limit
  const http = rateLimit(axiosInstance, {
    maxRequests: 12,
    perMilliseconds: 1000,
    maxRPS: 12
  });

  // Dispatch automatically freeze / unfreeze cart event, during request processing
  axiosInstance.interceptors.request.use(
    (config) => {
      events.b2bCartFreeze();
      return config;
    },
    (error) => {
      events.b2bCartUnfreeze();
      events.b2bCartApiFailure(error);
      return Promise.reject(error);
    }
  );
  axiosInstance.interceptors.response.use(
    (config) => {
      events.b2bCartUnfreeze();
      return config;
    },
    (error) => {
      events.b2bCartUnfreeze();
      events.b2bCartApiFailure(error);
      return Promise.reject(error);
    }
  );

  const shopifySettings = globalTheme.shopify();
  const url = `https://${shopifySettings.url}/api/${shopifySettings.api_version}/graphql.json`;
  const storeFrontAccessToken = shopifySettings.store_front_access_token;
  const shopifyDomain = globalTheme.siteUrl();

  const getHttpConfig = (data) => ({
    method: 'post',
    url,
    headers: {
      'X-Shopify-Storefront-Access-Token': storeFrontAccessToken,
      'Content-Type': 'application/json'
    },
    data
  });

  const getAdminHttpConfig = (data) => ({
    method: 'post',
    url: `${shopifyDomain}/graphql`,
    headers: {
      'Content-Type': 'application/json'
    },
    data
  });

  const getMarketsFromRecepients = () => {
    const rec = store.getters.recipients;
    const all = store.getters.allRecipients;
    const markets = [];
    // eslint-disable-next-line array-callback-return
    if (!rec) {
      return;
    }
    // eslint-disable-next-line array-callback-return
    rec.map((recipient) => {
      if (recipient.market === null) {
        return;
      }
      if (!markets.includes(recipient.market)) {
        if (all.includes(recipient.id)) {
          markets.push(recipient.market);
        }
      }
    });
  };

  // /**
  //  * @deprecated This is never used, remove it
  //  */
  // const updateMarketSpecificCarts = () => {
  //   const cart = [];
  //   const carts = [];
  //   store.getters.b2bCarts.forEach((singleCart) => {
  //     const thing = {};
  //     thing.market = singleCart.buyerIdentity.countryCode;
  //     thing.id = singleCart.id;
  //     thing.masterCart = store.getters.cart.id;
  //     thing.lines = singleCart.lines.edges;
  //     cart.push(thing);
  //   });
  //
  //   cart.forEach((singleCart) => {
  //     const data = JSON.stringify({
  //       query: `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  //             cartLinesUpdate(cartId: $cartId, lines: $lines) {
  //               cart {
  //                 id
  //                 attributes {
  //                     key
  //                     value
  //                   }
  //                 checkoutUrl
  //                 createdAt
  //                 totalQuantity
  //                 lines(first: 100) {
  //                   edges {
  //                     node {
  //                       id
  //                       recipient: attribute(key: "recipient"){
  //                         value
  //                       }
  //                       productId: merchandise {
  //                         ... on ProductVariant {
  //                            id
  //                         }
  //                       }
  //                     }
  //                   }
  //                 }
  //                 deliveryCost: deliveryGroups(first: 3){
  //                   edges{
  //                     node{
  //                       selectedDeliveryOption{
  //                         estimatedCost{
  //                           amount
  //                           currencyCode
  //                         }
  //                       }
  //                     }
  //                   }
  //                 }
  //                 buyerIdentity{
  //                   countryCode
  //                 }
  //               }
  //               userErrors {
  //                 field
  //                 message
  //               }
  //             }
  //           }`,
  //       variables: {
  //         cartId: singleCart.id,
  //         lines: []
  //       }
  //     });
  //     const config = getHttpConfig(data);
  //
  //     http(config)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           const thecart = response.data.data.cartLinesUpdate.cart;
  //           thecart.recipientCount = thecart.lines.edges.length;
  //           carts.push(thecart);
  //         }
  //       })
  //       .then(() => store.dispatch('setB2bCarts', carts));
  //   });
  // };

  const createMarketSpecificCarts = () => {
    const carts = [];
    const splitCart = [];
    store.getters.b2bCartLocations.forEach((location) => {
      splitCart[location] = [];
    });

    const currentCart = store.getters.cart.lines?.edges ?? [];
    // eslint-disable-next-line array-callback-return
    currentCart.map((line) => {
      const key = line.node.attributes.find((attr) => attr.key === 'recipient');
      if (key) {
        const recipient = store.getters.recipients.find(
          (reci) => reci.id === key.value
        );

        const exists =
          splitCart[recipient.market]?.find(
            (cart) => cart.recipient === key.value
          ) ?? false;

        if (exists) {
          exists.lines.push({
            merchandiseId: line.node.merchandise.id,
            quantity: line.node.quantity,
            attributes: {
              key: 'recipient',
              value: key.value
            }
          });
          return;
        }

        const input = {
          recipient: key.value,
          lines: []
        };

        input.lines.push({
          merchandiseId: line.node.merchandise.id,
          quantity: line.node.quantity,
          attributes: {
            key: 'recipient',
            value: key.value
          }
        });
        if (recipient.market && splitCart[recipient.market]) {
          splitCart[recipient.market].push(input);
        }
      }
    });

    store.getters.b2bCartLocations.forEach((location) => {
      const recepients = splitCart[location];
      const lineItems = [];
      recepients.forEach((rec) => {
        rec.lines.forEach((line) => {
          lineItems.push({
            merchandiseId: line.merchandiseId,
            quantity: line.quantity,
            attributes: line.attributes
          });
        });
      });

      const data = JSON.stringify({
        query: `mutation cartCreate($input: CartInput) {
              cartCreate(input: $input) {
                cart {
                  id
                  attributes {
                      key
                      value
                    }
                  checkoutUrl
                  createdAt
                  totalQuantity
                  lines(first: 100) {
                    edges {
                      node {
                        id
                        recipient: attribute(key: "recipient"){
                          value
                        }
                        productId: merchandise {
                          ... on ProductVariant {
                            id
                          }
                        }
                      }
                    }
                  }
                  deliveryCost: deliveryGroups(first: 3){
                    edges{
                      node{
                        selectedDeliveryOption{
                          estimatedCost{
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                  }
                  buyerIdentity{
                    countryCode
                  }
                }
                userErrors {
                  field
                  message
                }
              }
            }`,
        variables: {
          input: {
            attributes: [
              {
                key: 'company_id',
                value: store.getters.b2bId ?? 'something'
              }
            ],
            buyerIdentity: {
              countryCode: location
            },
            lines: lineItems
          }
        }
      });

      const config = getHttpConfig(data);

      http(config)
        .then((response) => {
          if (response.data.errors) {
            triggerErrorLog(response.data.errors);
          }

          if (response.status === 200) {
            const thecart = response.data.data.cartCreate.cart;
            thecart.recipientCount = recepients.length;
            thecart.masterCart = store.getters.cart.id;
            carts.push(thecart);
          }
        })
        .then(() => store.dispatch('setB2bCarts', carts));
    });
  };

  function removeNonLatin1Characters(inputString) {
    // @todo Review regexp to prevent warning
    // eslint-disable-next-line no-control-regex
    const latin1Regex = /[^\x00-\xFF]/g;
    return inputString.replace(latin1Regex, '');
  }

  const createDraftCartAsync = async (input) => {
    const theProducts = [];

    // Hash must include discount code
    const discountCode = store.getters.getDiscountCode ?? '';
    const newHash = btoa(
      `${removeNonLatin1Characters(JSON.stringify(input))}:${discountCode}`
    );
    const oldHash = store.getters.b2bApiCartHash;

    // @todo es-lint: Function is used before definition
    // eslint-disable-next-line no-use-before-define
    await processAllLineItems(input, theProducts);

    // eslint-disable-next-line no-console
    console.count('API');

    if (newHash === oldHash) {
      // eslint-disable-next-line no-console
      console.count('API');
      // eslint-disable-next-line no-console
      console.warn('Duplicate API request. Skipping.');
      return {
        status: 'SKIPPED'
      };
    }

    // eslint-disable-next-line no-console
    console.countReset('API');

    await store.dispatch('setB2bApiCartHash', newHash);

    // @todo es-lint: Function is used before definition
    // eslint-disable-next-line no-use-before-define
    return submitOrderRequest(input, theProducts);
  };

  const processAllLineItems = async (input, theProducts) => {
    await Promise.all(
      Object.keys(input.allLineItems).map(async (id) => {
        const item = input.allLineItems[id];
        // @todo es-lint: Function is used before definition
        // eslint-disable-next-line no-use-before-define
        await processItemProducts(
          item,
          theProducts,
          input.market.toUpperCase() // Market must be uppercase
        );
      })
    );
  };

  const processItemProducts = async (item, theProducts, market) => {
    const personalisation = (item.attributes || []).find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.personalisation
    );

    const isEngraveProduct = (item.attributes || []).find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.is_engrave_product
    );

    const engraveVariant = (item.attributes || []).find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.b2b_engrave_variant
    );

    const engraveVariantDiscounted = (item.attributes || []).find(
      (attribute) =>
        attribute.key ===
        cartContent.lineItemsAttributes.b2b_engrave_variant_discounted
    );

    const giftBag = (item.attributes || []).find(
      (attribute) => attribute.key === cartContent.lineItemsAttributes.gift_bag
    );

    const giftBagVariant = (item.attributes || []).find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.b2b_gift_bag_variant
    );

    const bottledBy = (item.attributes || []).find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.bottled_by
    );

    const bottledByFor = (item.attributes || []).find(
      (attribute) => attribute.key === cartContent.lineItemsAttributes.for
    );

    const bottledByOnly = !!bottledBy?.value && !bottledByFor?.value;

    const linkedVariantId = (item.attributes || []).find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.b2b_linked_variant_id
    );

    const productLink = (item.attributes || []).find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.product_link
    );

    await Promise.all(
      Object.keys(item.products).map(async (productId) => {
        const product = item.products[productId];
        // @todo es-lint: Function is used before definition
        // eslint-disable-next-line no-use-before-define
        const price = await getPriceForProduct(product, market);

        // @todo es-lint: Function is used before definition
        // eslint-disable-next-line no-use-before-define
        const newProduct = createProductObject(item, product, price, {
          personalisation: personalisation?.value || null,
          is_engrave_product: isEngraveProduct?.value || null,
          engraveVariant: engraveVariant?.value || null,
          engraveVariantDiscounted: engraveVariantDiscounted?.value || null,
          giftBag: giftBag?.value || null,
          giftBagVariant: giftBagVariant?.value || null,
          productLink: productLink?.value || null,
          linkedVariantId: linkedVariantId?.value || null,
          bottledBy: bottledBy?.value || null,
          bottledByOnly: bottledByOnly?.value || null,
          bottledByFor: bottledByFor?.value || null
        });

        theProducts.push(newProduct);
      })
    );

    // @todo es-lint: Function is used before definition
    // eslint-disable-next-line no-use-before-define
    await processGroupedProducts(theProducts, market);
  };

  const getEngravingProductPrice = async (productId) =>
    new Promise((resolve) => {
      const cartInstance = cartService.getInstance();
      cartInstance.getEngravingProduct(productId, (resultProduct) => {
        resolve(
          parseFloat(resultProduct.price.edges[0].node.priceV2.amount ?? '0.0')
        );
      });
    });

  const getPriceForProduct = async (product, market) => {
    let price;

    if (product.giftBag) {
      price = await getEngravingProductPrice(product.productId);
    } else {
      price = await globalTheme.priceByCountry(product.productId, market);
    }

    return Number(price.toFixed(2));
  };

  const createProductObject = (item, product, price, attributes) => ({
    recipientId: item.id,
    recipientName: item.name,
    image: item.image,
    productCode: product.variantId,
    quantity: product.quantity,
    shippingCost: item.shippingCost,
    productName: `${product.quantity}x ${product.title} for ${item.name}`,
    productPrice: price,
    ...attributes
  });

  const processGroupedProducts = async (theProducts, market) => {
    const groupedProducts = theProducts.reduce((result, product) => {
      if (product.productCode !== 'shipping') {
        if (!result[product.recipientId]) {
          result[product.recipientId] = {
            recipientId: product.recipientId,
            productId: product.productCode,
            totalProductPrice: 0
          };
        }

        result[product.recipientId].totalProductPrice += product.productPrice;
      }

      return result;
    }, {});

    const groupedProductsArray = Object.values(groupedProducts);

    await Promise.all(
      groupedProductsArray.map(async (groupedProduct) => {
        const product = await globalTheme.productByVariantId(
          groupedProduct.productId
        );

        await store.dispatch('setB2bCartTotalCartPriceForUser', {
          market,
          userId: groupedProduct.recipientId,
          total: groupedProduct.totalProductPrice,
          productId: product.id
        });
      })
    );
    // eslint-disable-next-line no-use-before-define
    await addShippingProduct(theProducts, market);
  };

  const convertToKilograms = (weightObj, defaultValue = 0.0) => {
    if (
      !weightObj ||
      !weightObj.weight ||
      !weightObj.weight.unit ||
      typeof weightObj.weight.value !== 'number'
    ) {
      // eslint-disable-next-line no-console
      console.log(
        'b2bCartHelpers.convertToKilograms failed: Invalid weight object',
        { weightObj }
      );
      return defaultValue;
    }

    const conversionRates = {
      GRAMS: 0.001,
      KILOGRAMS: 1,
      OUNCES: 0.0283495,
      POUNDS: 0.453592
    };

    const { unit, value } = weightObj.weight;

    if (!conversionRates[unit]) {
      // eslint-disable-next-line no-console
      console.log(
        'b2bCartHelpers.convertToKilograms failed: Unsupported weight unit',
        { weightObj }
      );
      return defaultValue;
    }

    const kgValue = value * conversionRates[unit];

    return parseFloat(kgValue.toFixed(5));
  };

  const addShippingProduct = async (theProducts, market) => {
    const groupedProducts = theProducts.reduce((grouped, product) => {
      const { recipientId } = product;
      if (!grouped[recipientId]) {
        grouped[recipientId] = {
          recipientId,
          productCode: product.productCode,
          recipientName: product.recipientName,
          quantity: product.quantity,
          totalProductPrice: 0,
          associatedEngravingProduct: product.is_engrave_product
        };
      }

      grouped[recipientId].totalProductPrice +=
        product.productPrice * product.quantity;
      return grouped;
    }, {});

    // Collect all promises for productByVariantId calls
    const productPromises = Object.values(groupedProducts).map((recipient) =>
      globalTheme.productByVariantId(recipient.productCode)
    );

    // Wait for all promises to resolve
    const products = await Promise.all(productPromises);

    for (let i = 0; i < products.length; i++) {
      const result = products[i];
      const recipient = Object.values(groupedProducts)[i];
      let engravingPrice = 0;

      // @todo Possible issue: await in a loop
      // eslint-disable-next-line no-await-in-loop
      const theProduct = await globalTheme.productByVariantId(
        recipient.productCode
      );

      if (recipient.associatedEngravingProduct) {
        // @todo Possible issue: await in a loop
        engravingPrice =
          // eslint-disable-next-line no-await-in-loop
          (await getEngravingProductPrice(
            recipient.associatedEngravingProduct
          )) * recipient.quantity;
      }

      const weight = convertToKilograms(
        theProduct.variants[0].inventoryItem.measurement ?? {},
        0.0
      );
      const totalWeight = weight * recipient.quantity;

      const shippingPayload = {
        market,
        productId: result.id,
        weight: totalWeight,
        carttotal: recipient.totalProductPrice + engravingPrice,
        recipientId: recipient.recipientId
      };

      // Use await here to ensure getShippingCost is completed before moving on
      // eslint-disable-next-line no-await-in-loop
      const shippingCost = await store.dispatch(
        'getShippingCost',
        shippingPayload
      );

      const newProduct = {
        recipientId: recipient.recipientId,
        recipientName: recipient.recipientName,
        productCode: 'shipping',
        quantity: 1,
        shippingCost: 0, // Adjust as needed
        productName: `Shipping for ${recipient.recipientName}`,
        productPrice: shippingCost
      };

      theProducts.push(newProduct);
    }
  };

  const handleOrderError = (error) => {
    // eslint-disable-next-line no-console
    console.error('createDraftCartAsync failure', error);
    events.b2bCartApiFailure(error);
  };

  const submitOrderRequest = async (input, theProducts) => {
    const data = JSON.stringify({
      query: `mutation b2bMarketCartToOrder($input: B2bMarketCartToOrderInput!){
                  b2bMarketCartToOrder(input: $input) {
                      status
                      invoiceUrl
                      totalPrice
                      totalPriceFormatted
                      name
                      id
                      discountAutomatic
                      error
                  }
                }`,
      variables: {
        input: {
          id: store.getters.b2bCarts[input.market].order.id ?? null,
          products: theProducts,
          discountCode: store.getters.getDiscountCode ?? '',
          customerId: store.getters.user.id,
          email: store.getters.email ?? '',
          market: input.market.toUpperCase(),
          globalGiftMessage: store.getters.getGlobalGiftMessage,
          purchasingEntity: {
            purchasingCompany: {
              companyContactId: input.company.contactId,
              companyId: input.company.companyId,
              companyLocationId: input.company.locationId
            }
          }
        }
      }
    });

    const config = getAdminHttpConfig(data);

    try {
      // Variables date and time are never used, commented
      // const date = new Date();
      // const time = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} -- ${date.getMilliseconds()}`;
      const response = await axiosInstance(config);

      if (response.data.errors) {
        triggerErrorLog(response.data.errors);
      }
      if (
        response.status === 200 &&
        response?.data?.data?.b2bMarketCartToOrder
      ) {
        // eslint-disable-next-line no-use-before-define
        return handleOrderResponse(response.data.data.b2bMarketCartToOrder);
      }
    } catch (error) {
      handleOrderError(error);
    }
  };

  const handleOrderResponse = (orderData) => {
    const error = orderData?.error;

    if (error && error.length) {
      // eslint-disable-next-line no-console
      console.error('createDraftCartAsync error', error);
      events.b2bCartApiFailure(error);
    }

    return orderData;
  };

  // This is used by customer area --> previous order
  const getMasterOrderWithDetails = async (input) => {
    const id = (
      input.order_id ||
      store.getters.b2bCarts[input.market]?.order?.id ||
      ''
    ).replace('gid://shopify/Order/', '');
    const data = JSON.stringify({
      query: `query b2bMarketGetOrder($id: String){
                b2bMarketGetOrder(id: $id) {
                    currency
                    status
                    totalPrice
                    totalPriceFormatted
                    name
                    id
                    lineItems {
                      id
                      name
                      quantity
                      price
                      priceFormatted
                      properties {
                        name
                        value
                      }
                      address {
                          address1
                          address2
                          city
                          postcode
                          country
                      }
                      phone
                      attributes {
                        key
                        value
                      }
                      giftBag
                      image
                      requires_personalisation {
                         value
                      }
                      productId
                      title
                      variantId
                    }
                    currency
                    market
                    error
                }
              }`,
      variables: {
        id
      }
    });

    const config = getAdminHttpConfig(data);

    try {
      const response = await axiosInstance(config);
      if (response.data.errors) {
        triggerErrorLog(response.data.errors);
      }
      if (response.status === 200) {
        return response.data.data.b2bMarketGetOrder;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const deleteDraftOrder = async (input) => {
    const data = JSON.stringify({
      query: `mutation b2bMarketDeleteOrder($input: B2bMarketDeleteOrderInput!){
                b2bMarketDeleteOrder(input: $input) {
                    status
                    error
                }
              }`,
      variables: {
        input: {
          id: store.getters.b2bCarts[input.market].order.id ?? null
        }
      }
    });

    const config = getAdminHttpConfig(data);

    try {
      const response = await axiosInstance(config);
      if (response.data.errors) {
        triggerErrorLog(response.data.errors);
      }
      if (response.status === 200) {
        return response.data.data.b2bMarketDeleteOrder;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const deleteOrderById = async (input, callback = undefined) => {
    const isLegacyId = /^\d+$/.test(input);
    const orderId = isLegacyId ? `gid://shopify/Order/${input}` : input;

    const data = JSON.stringify({
      query: `mutation b2bMarketDeleteOrder($input: B2bMarketDeleteOrderInput!){
                b2bMarketDeleteOrder(input: $input) {
                    status
                    error
                }
              }`,
      variables: {
        input: {
          id: orderId
        }
      }
    });

    const config = getAdminHttpConfig(data);

    try {
      const response = await axiosInstance(config);
      if (response.data.errors) {
        triggerErrorLog(response.data.errors);
      }
      if (response.status === 200) {
        callback(response.data.data.b2bMarketDeleteOrder);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  /**
   * @param input
   * @param {Function|undefined} callback
   */
  const getOrderStatus = async (input, callback = undefined) => {
    if (!input) {
      // eslint-disable-next-line no-unused-expressions
      callback && callback({ status: 'error', error: 'No order id provided' });
      return;
    }

    const data = JSON.stringify({
      query: `query b2bOrder ($id: String){
                b2bOrder(id: $id) {
                    status
                }
              }`,
      variables: {
        id: input
      }
    });

    const config = getAdminHttpConfig(data);

    try {
      const response = await axiosInstance(config);
      if (response.status === 200) {
        callback(response.data.data.b2bOrder);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  /**
   * @param input
   * @param {Function|undefined} callback
   */
  const getChildOrders = (input, callback = undefined) => {
    const data = JSON.stringify({
      query: `query b2bChildOrders ($id: String){
                b2bChildOrders(id: $id) {
                      id
                      number
                      status
                      name
                      trackingCode
                      trackingUrl
                      shippingMethod
                      delivered
                      address {
                          address1
                          address2
                          city
                          postcode
                          country
                      }
                      phone
                      shippingCost
                }
              }`,
      variables: {
        id: input
      }
    });

    const config = getAdminHttpConfig(data);

    http(config).then((response) => {
      if (response.data.errors) {
        triggerErrorLog(response.data.errors);
      }
      if (response.status === 200) {
        if (typeof callback === 'function') {
          callback(response.data.data.b2bChildOrders);
        }
      }
    });
  };

  /**
   * @param input
   * @param {Function|undefined} callback
   */
  // eslint-disable-next-line no-unused-vars
  const updateShopifyB2bGroup = async (input, callback) => {
    const data = JSON.stringify({
      query: `mutation b2bGroupUpdate($input: B2bGroupUpdateInput!){
                  b2bGroupUpdate(input: $input){
                      value
                      errors
                  }
              }`,
      variables: {
        input: {
          id: store.getters.b2bId,
          value: input
        }
      }
    });

    const config = getAdminHttpConfig(data);

    await http(config).then((response) => {
      if (response.data.errors) {
        triggerErrorLog(response.data.errors);
      }
      if (response.status === 200) {
        // eslint-disable-next-line no-console
        console.log('B2B Group Updated', response.data);
      }
    });
  };

  const normaliseLineItemAttributes = (attributes, payload) => {
    // Check attributes type
    if (!isArray(attributes)) {
      return [];
    }

    // Clone attributes
    attributes = (attributes || []).slice();
    if (!attributes.length) {
      return attributes;
    }

    // Destructure payload
    const { add, remove } = isObject(payload) ? payload : {};

    // Remove duplicated attributes
    attributes = uniqBy(attributes, 'key');

    // Add or replace attributes
    if (isArray(add)) {
      add.forEach((item) => {
        const index = findIndex(attributes, ['key', item.key]);
        if (index !== -1) {
          attributes[index].value = item.value;
        } else {
          attributes.push({ key: item.key, value: item.value });
        }
      });
    }

    // Remove attributes
    if (isArray(remove)) {
      const removeAttributes = remove.map((item) => item.key);
      removeFunc(
        attributes,
        (item) => removeAttributes.indexOf(item.key) !== -1
      );
    }

    return attributes;
  };

  return {
    getMarketsFromRecepients,
    createMarketSpecificCarts,
    // createDraftCart,
    createDraftCartAsync,
    deleteDraftOrder,
    deleteOrderById,
    getMasterOrderWithDetails,
    getOrderStatus,
    getChildOrders,
    normaliseLineItemAttributes,
    updateShopifyB2bGroup,
    convertToKilograms
  };
}

const b2bCartHelpers = (() => {
  let instance = null;
  return {
    getInstance: () => {
      // Lazy initialisation of instance
      if (instance === null) {
        instance = new B2BCartServiceConstructor();
      }
      return instance;
    }
  };
})();

export default b2bCartHelpers;
